<!-- =========================================================================================
    File Name: ResetPassword.vue
    Description: Reset Password Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div class="h-screen flex w-full bg-img">
    <div class="vx-col sm:w-3/5 md:w-3/5 lg:w-3/4 xl:w-3/5 mx-auto self-center">
      <vx-card>
        <div slot="no-body" class="full-page-bg-color">
          <div class="vx-row">
            <div
              class="vx-col hidden sm:hidden md:hidden lg:block lg:w-1/2 mx-auto self-center"
            >
              <img
                src="@/assets/images/pages/reset-password.png"
                alt="login"
                class="mx-auto"
              />
            </div>
            <div
              class="vx-col sm:w-full md:w-full lg:w-1/2 mx-auto self-center d-theme-dark-bg"
            >
              <div class="p-8">
                <div class="vx-card__title mb-8">
                  <h4 class="mb-4">Resetar Senha</h4>
                  <p>Por favor, insira sua nova senha.</p>
                </div>
                <!-- <vs-input type="email" label-placeholder="Email" v-model="value1" class="w-full mb-6" /> -->
                <vs-input
                  type="password"
                  label-placeholder="Senha"
                  v-model="password"
                  class="w-full mb-6"
                />
                <vs-input
                  type="password"
                  label-placeholder="Confirmar Senha"
                  v-model="confirmPassword"
                  class="w-full mb-8"
                />

                <div
                  class="flex flex-wrap justify-between flex-col-reverse sm:flex-row"
                >
                  <vs-button
                    type="border"
                    to="/login"
                    class="w-full sm:w-auto mb-8 sm:mb-auto mt-3 sm:mt-auto"
                    >Voltar ao login</vs-button
                  >
                  <vs-button class="w-full sm:w-auto" @click="resetPassword"
                    >Enviar</vs-button
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
import jwt_decode from 'jwt-decode'
export default {
  data () {
    return {
      password: '',
      confirmPassword: '',
      user_email: ''
    }
  },
  async created () {
    await this.setLoginParameters()
  },
  methods: {
    validateStrengthPassword () {
      const passw = /^(?=.*\d)(?=.*[a-z])(?=.*[@$!%*#?&])(?=.*[A-Z]).{6,20}$/
      if (this.password.match(passw)) {
        return true
      } else if (!this.password.match(passw)) {
        this.$vs.notify({
          title: 'Atenção',
          text:
            'A senha deve conter pelo menos um número, letra maiúscula, letra minúscula, símbolos e pelo menos 6 caracteres',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning'
        })
        return false
      }

      if (this.confirmPassword.match(passw)) {
        return true
      } else {
        this.$vs.notify({
          title: 'Atenção',
          text:
            'A senha deve conter pelo menos um número, letra maiúscula, letra minúscula, símbolos e pelo menos 6 caracteres',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning'
        })
        return false
      }
    },
    async setLoginParameters () {
      await this.$store
        .dispatch('auth/getLoginParameters', {
          source_domain: window.location.origin.split('//')[1]
        })
        .then((data) => {
          this.app_token = this.$store.state.auth.app_token
          this.api_url = this.$store.state.auth.api_url
          document.title = this.$store.state.auth.login_parameters.web_tab_title
        })
        .catch((err) => {
          console.log(err)
        })
    },
    async login () {
      // Loading

      if (!this.$store.state.auth.api_url || !this.$store.state.auth.app_token) {
        await this.setLoginParameters()
      }

      const payload = {

        userDetails: {
          email: this.user_email,
          password: this.password
        },
        api_url: this.api_url,
        app_token: this.app_token
      }

      this.$store.dispatch('auth/login', payload)
        .then(() => {
          this.$vs.loading.close()
        })
        .catch((e) => {
          this.$vs.loading.close()
          this.$vs.notify({
            title: 'Erro',
            text: e.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
        })
    },
    resetPassword () {
      if (!this.validateStrengthPassword()) return

      if (this.password !== this.confirmPassword) {
        this.$vs.notify({
          title: 'Atenção',
          text: 'As senhas não correspondem',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning'
        })

        return
      }

      this.$vs.loading()

      fetch(`${this.$store.state.auth.api_url}`, {
        method: 'POST', headers: {"Content-Type": "application/json"},
        body: JSON.stringify({
          command: 'change_user_password_by_token',
          parameters: {
            application_token: this.$store.state.auth.app_token,
            remember_token: this.$route.params.rememberToken,
            password: this.password
          }
        })
      })
        .then((response) => {
          if (response.status === 200) {
            response.json().then((responseData) => {

              const decoded = jwt_decode(this.$route.params.rememberToken)

              this.user_email = decoded['user_email']

              this.login()
            })
          } else {
            this.$vs.notify({
              title: 'Atenção',
              text: 'O token para recuperação de senha expirou.',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'warning'
            })

            this.$vs.loading.close()
          }
        })
    }
  }
}
</script>
